import React, { useEffect, useRef, useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ContextBoard } from "../context/ContextBoard";

const PrivateRouteDeo = ({ children, tokenKey = "deotoken" }) => {
  const location = useLocation();
  const token = sessionStorage.getItem(tokenKey);

  useEffect(() => {}, []);

  if (!token) {
    return <Navigate to="/deo" />;
  }

  return children;
};

export default PrivateRouteDeo;
